import { h, Component } from "preact";
import PropTypes from "prop-types";
import { connect } from "preact-redux";

import styles from "./HappinessSubmitter.scss";

import { postNewEntry } from "../../actions";

import { TextArea, Button } from "semantic-ui-react";

import { Loader } from "semantic-ui-react";
import { MoodSelector } from "../moodSelector";

export class HappinessSubmitter extends Component {
  constructor(props) {
    super(props);

    this.onPostEntry = this.onPostEntry.bind(this);
    this.onSelectorChanged = this.onSelectorChanged.bind(this);
    this.onTextChanged = this.onTextChanged.bind(this);

    this.state = {
      selectedHappiness: null,
      description: "",
    };
  }

  onSelectorChanged(value) {
    this.setState({ selectedHappiness: value });
    if (value) document.getElementById("moodDescriptionTextfield").focus();
  }

  onTextChanged(value) {
    this.setState({ description: value });
  }

  onPostEntry() {
    this.props.postNewEntry({
      rating: this.state.selectedHappiness,
      description: this.state.description,
      date: new Date().toISOString(),
    });

    this.setState({
      selectedHappiness: null,
      description: "",
    });
  }

  render() {
    const { postLoading, postError } = this.props;
    return (
      <div className={styles.container}>
        <div className={styles.item}>
          {postLoading || postError ? (
            <div>
              {postError}
              <br />
              <Loader active indeterminate>
                Posting new entry
              </Loader>
            </div>
          ) : (
            <div>
              <form onSubmit={this.onPostEntry}>
                <div>
                  <MoodSelector
                    selected={this.state.selectedHappiness}
                    onChanged={this.onSelectorChanged}
                  />
                  <TextArea
                    id="moodDescriptionTextfield"
                    onChange={e => this.onTextChanged(e.target.value)}
                    value={this.state.description}
                    className={styles.textfield}
                    placeholder="Give a description"
                    rows={5}
                  />
                </div>
                <br />
                <Button type="submit" disabled={!this.state.selectedHappiness}>
                  Submit Happiness
                </Button>
              </form>
            </div>
          )}
        </div>
      </div>
    );
  }
}

HappinessSubmitter.propTypes = {
  postLoading: PropTypes.bool.isRequired,
  postSuccess: PropTypes.bool.isRequired,
  postError: PropTypes.any.isRequired,

  postNewEntry: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  postLoading: state.diary.postLoading,
  postSuccess: state.diary.postSuccess,
  postError: state.diary.postError,
});

const mapDispatchToProps = { postNewEntry };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HappinessSubmitter);



// WEBPACK FOOTER //
// ./src/modules/diary/components/happinessSubmitter/HappinessSubmitter.js